import { serviceAfterSalesSettings } from "./service-after-sales-settings";
import { serviceAssets } from "./service-assets";
import { serviceCards } from "./service-cards";
import { serviceCategorization } from "./service-categorization";
import { serviceConnectors } from "./service-connectors";
import { serviceConnectorsB } from "./service-connectors-b";
import { serviceConnectorsC } from "./service-connectors-c";
import { serviceConnectorsD } from "./service-connectors-d";
import { serviceConnectorsE } from "./service-connectors-e";
import { serviceExtras } from "./service-extras";
import { serviceField } from "./service-field";
import { serviceImport } from "./service-import";
import { serviceInbox } from "./service-inbox";
import { serviceLeadConvert } from "./service-lead-convert";
import { serviceMerge } from "./service-merge";
import { serviceImportHistory, serviceProductFunnel, serviceRmaReplacement } from "./service-s4-extras";
import { serviceSpares } from "./service-spares";
import { serviceInstallations } from "./service-installations";
import { serviceQuarantine } from "./service-quarantine";
import { serviceReports } from "./service-reports";
import { serviceReportsField } from "./service-reports-field";
import { serviceContact } from "./service-contacts";
import { serviceContracts } from "./service-contracts-ui";
import { serviceOrg } from "./service-organisations";
import { serviceSettings } from "./service-settings";
import { serviceSettingsA } from "./service-settings-a";
import { serviceSettingsB } from "./service-settings-b";
import { serviceCatalogue } from "./service-catalogue";
import { serviceCommerce } from "./service-commerce";
import { serviceOrders } from "./service-orders";
import { serviceRmas } from "./service-rmas";
import { serviceTicketAfterSales } from "./service-ticket-after-sales";
import { serviceTicketDetail } from "./service-ticket-detail";
import { serviceTickets } from "./service-tickets";
import { serviceVisits } from "./service-visits";

/** Service Desk (M27): mga shell ng console (plan lock, naka-off, hindi pa tapos) sa S0. */
export const service = {
  settings: { ...serviceSettings, ...serviceSettingsA, ...serviceSettingsB, assetsWarranty: serviceAfterSalesSettings.assetsWarranty, visitTemplates: serviceAfterSalesSettings.visitTemplates, nav: { ...serviceSettingsA.nav, ...serviceSettingsB.nav, ...serviceQuarantine.nav, ...serviceAfterSalesSettings.nav, import: serviceImport.nav, ...serviceCommerce.nav } },
  lock: { available: "Available sa {{plan}}" },
  upgrade: {
    title: "Kasama ang {{area}} mula sa planong {{plan}}",
    body: "Pinagsasama ng Service Desk ang mga ticket, organisasyon ng kliyente at, sa Pro, mga asset, pagbisita sa field at order. Mag-upgrade para i-on ang {{area}}.",
    cta: "Tingnan ang mga plano",
  },
  off: {
    title: "Hindi pa naka-on ang Service Desk sa workspace na ito",
    body: "Unti-unti itong inilalabas, workspace por workspace. Walang kulang sa panig mo; magtanong sa Sagot team kung gusto mo ng maagang access.",
  },
  soon: {
    title: "Bubukas ang {{area}} kasabay ng Service Desk",
    body: "Kasama na ito sa plano mo. Darating ang screen sa susunod na release at naghihintay na ang iyong data.",
  },
  error: {
    title: "Hindi ma-load ang Service Desk",
    body: "Tingnan ang koneksyon mo at subukan ulit. Walang nabago.",
    retry: "Subukan ulit",
  },
  chips: {
    actionNeeded: "May kailangang gawin",
    category: {
      new: "Bago",
      open: "Bukas",
      pending: "Naghihintay (sagot ng kliyente)",
      on_hold: "Naka-hold (third party)",
      resolved: "Naayos na",
      closed: "Sarado",
    },
    status: {
      staff: { new: "Bago", open: "Bukas", pending: "Naghihintay", on_hold: "Naka-hold", resolved: "Naayos na", closed: "Sarado" },
      client: {
        new: "Natanggap",
        open: "Inaasikaso",
        pending: "Hinihintay ang sagot mo",
        on_hold: "Naka-hold",
        resolved: "Naayos na — pakikumpirma",
        closed: "Sarado",
      },
    },
    priority: { urgent: "Apurahan", high: "Mataas", normal: "Karaniwan", low: "Mababa" },
    verification: {
      verified: "Na-verify",
      unverified: "Hindi pa na-verify",
      method: { widget_jwt: "Sign-in sa website", email_otp: "Code sa e-mail", magic_link: "Magic link", staff_verified: "Na-check ng staff" },
    },
    sla: {
      metric: { first_response: "Unang sagot", next_response: "Susunod na sagot", resolution: "Resolusyon", onsite_response: "Tugon on-site" },
      met: "Nakamit ang {{metric}}",
      due: "{{metric}} hanggang {{due}}",
      onTrack: "{{metric}} ay nasa oras",
      dueSoon: "{{metric}} malapit nang matapos",
      breached: "Lumampas ang {{metric}}",
      paused: "Naka-pause ang {{metric}}",
      pausedFor: "Naka-pause: {{reason}}",
      none: "Walang target na {{metric}}",
      percentLeft: "{{percent}}% ng oras ang natitira",
      allTargets: "Lahat ng target ng ticket na ito",
      noTargets: "Walang SLA target",
      targetLine: "{{text}} ({{percent}}% natitira)",
    },
  },
  back: "Bumalik sa dashboard",
  loading: "Naglo-load",
  areas: {
    tickets: { title: "Mga Ticket", summary: "Lahat ng hiling ng kliyente sa iisang pila, may may-ari, due time at mga sagot." },
    organisations: { title: "Mga Organisasyon", summary: "Ang mga kumpanya at institusyong pinaglilingkuran mo, kasama ang kanilang site at tao." },
    contacts: { title: "Mga Contact", summary: "Mga tao ng kliyente, paano sila na-verify at saang organisasyon sila kabilang." },
    assets: { title: "Mga Asset", summary: "Mga naka-install na kagamitan na may warranty, kontrata at kasaysayan ng serbisyo." },
    installations: { title: "Mga Installation", summary: "Mga proyekto ng delivery at commissioning na may yugto at bukas na item." },
    visits: { title: "Mga Pagbisita sa Field", summary: "Mag-iskedyul ng engineer, mag-dispatch at kumuha ng ulat at sign-off." },
    orders: { title: "Mga Order", summary: "Mga order, quote at approval na dumaan sa assistant." },
    catalogue: { title: "Katalogo", summary: "Mga produkto at presyo mula sa order system mo." },
    "service-reports": { title: "Mga Ulat sa Serbisyo", summary: "Oras ng sagot, resolusyon, kasiyahan at workload sa isang tingin." },
    "service-settings": { title: "Settings ng Serbisyo", summary: "Mga uri ng ticket, field, status, routing, SLA at automation." },
  },
  assets: serviceAssets,
  contracts: serviceContracts,
  installations: serviceInstallations,
  visits: serviceVisits,
  field: serviceField,
  extras: serviceExtras,
  org: serviceOrg,
  contact: serviceContact,
  import: serviceImport,
  tickets: serviceTickets,
  ticketDetail: { ...serviceTicketDetail, after: serviceTicketAfterSales },
  rmas: serviceRmas,
  orders: serviceOrders,
  catalogue: serviceCatalogue,
  commerce: serviceCommerce.commerce,
  ordering: serviceCommerce.ordering,
  categorization: serviceCategorization,
  reports: { ...serviceReports, tabs: { ...serviceReports.tabs, ...serviceReportsField.tabs, ...serviceCategorization.tabs }, field: serviceReportsField.field, insight: serviceReportsField.insight },
  connectors: { ...serviceConnectors, ...serviceConnectorsB, ...serviceConnectorsC, ...serviceConnectorsD, ...serviceConnectorsE },
  quarantine: serviceQuarantine,
  inbox: serviceInbox,
  cards: serviceCards,
  merge: serviceMerge,
  spares: serviceSpares,
  leadConvert: serviceLeadConvert,
  rmaReplacement: serviceRmaReplacement,
  importHistory: serviceImportHistory,
  productFunnel: serviceProductFunnel,
} as const;
